module.exports = __webpack_public_path__ + "static/media/hanakawado-asakusa-3.8f58407b.jpg";